import styled from "@emotion/styled";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { MDSLoadingDotsSize } from "./loading-dots.types";

interface StyledLoadingDotsProps {
  size: MDSLoadingDotsSize;
}

const getSizeStyles = (size: MDSLoadingDotsSize) => {
  switch (size) {
    case MDSLoadingDotsSize.Small:
      return {
        width: "24px",
        height: "24px",
      };
    case MDSLoadingDotsSize.Medium:
      return {
        width: "32px",
        height: "32px",
      };
    case MDSLoadingDotsSize.Large:
      return {
        width: "48px",
        height: "48px",
      };
    default:
      return {
        width: "32px",
        height: "32px",
      };
  }
};

export const StyledLoadingDotsContainer = styled.div<StyledLoadingDotsProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${({ size }) => getSizeStyles(size)}
`;

export const StyledDotLottieReact = styled(DotLottieReact)`
  width: 100%;
  height: 100%;
`;
